import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

const TaskFilesList = ({ taskId }) => {
  const { currentLang, token, API_URL } = useAuth();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchFiles();
    // eslint-disable-next-line
  }, [taskId]);

  const fetchFiles = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await fetch(`${API_URL}${currentLang}/seo-tasks/${taskId}/files`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setFiles(data.data || []);
      } else {
        throw new Error(data.message || 'Ошибка загрузки файлов');
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      return new Date(dateString).toLocaleDateString('ru-RU', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return dateString;
    }
  };

  const getFileIcon = (type) => {
    const iconMap = {
      pdf: '📄',
      doc: '📝',
      docx: '📝',
      xls: '📊',
      xlsx: '📊',
      ppt: '📋',
      pptx: '📋',
      txt: '📄',
      jpg: '🖼️',
      jpeg: '🖼️',
      png: '🖼️',
      gif: '🖼️',
      zip: '📦',
      rar: '📦',
      mp4: '🎥',
      mp3: '🎵',
      default: '📎'
    };
    return iconMap[type?.toLowerCase()] || iconMap.default;
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-4">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
        {error}
      </div>
    );
  }

  if (!files.length) {
    return null;
  }

  return (
    <div className="mt-8">
      <h4 className="text-md font-semibold mb-4 text-gray-900">
        {currentLang === 'ru' ? 'Файлы задачи' : 'Task Files'}
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {files.map((file) => (
          <div
            key={file.id}
            className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start space-x-3 mb-3">
              <div className="text-3xl flex-shrink-0">
                {getFileIcon(file.type)}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate" title={file.name}>
                  {file.name}
                </p>
                <p className="text-xs text-gray-500">
                  {formatFileSize(file.size)}
                </p>
              </div>
            </div>
            <div className="space-y-2 text-xs text-gray-500">
              <div className="flex justify-between">
                <span>{currentLang === 'ru' ? 'Загружен:' : 'Uploaded:'}</span>
                <span>{formatDate(file.date)}</span>
              </div>
              <div className="flex justify-between">
                <span>{currentLang === 'ru' ? 'Автор:' : 'Author:'}</span>
                <span className="truncate ml-2">{file.user_name || `ID: ${file.uid}`}</span>
              </div>
            </div>
            <div className="flex justify-end items-center mt-3 pt-3 border-t border-gray-100">
              <a
                href={`${API_URL}${file.url.substring(1)}`}
                download={file.name}
                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
              >
                {currentLang === 'ru' ? 'Скачать' : 'Download'}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskFilesList; 